import React from 'react';

const VendorCard = ({ vendorLocationData, isSelected, onSelect, onShowDetails, routeDistances, isTowingService, hasFuelLocation }) => {
  const { location, distance_km, operating_hours } = vendorLocationData;
  const { vendor, manager_user, location_address } = location;

  // Get route information for this vendor
  const vendorRouteInfo = routeDistances?.[location.id];
  
  // Use calculated total distance if available, otherwise fallback to straight line distance
  const displayDistance = vendorRouteInfo?.totalDistance || distance_km;

  const formatAddress = (address) => {
    if (!address) return 'N/A';
    const parts = [
      address.address,
      address.city,
      address.state
    ].filter(Boolean);
    return parts.join(', ');
  };

  return (
    <div 
      className={`border rounded-lg p-4 transition-all duration-200 cursor-pointer ${
        isSelected 
          ? 'border-blue-500 bg-blue-50 shadow-md transform scale-[1.02] ring-2 ring-blue-200' 
          : 'hover:border-gray-300 hover:shadow-sm'
      }`}
      data-vendor-id={location.id}
      onClick={() => {
        console.log('Vendor card clicked:', location.id, 'isSelected:', isSelected);
        onSelect && onSelect(location.id);
      }}
    >
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h4 className="font-medium text-lg text-gray-800">{vendor.vendor_name}</h4>
            {isSelected && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                Selected
              </span>
            )}
            {location.dealer_id && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                Dealer
              </span>
            )}
          </div>
          <div className="text-sm text-gray-600 mt-2 space-y-1">
            <p>
              <span className="font-medium">Manager:</span> {manager_user.name}
            </p>
            <p>
              <span className="font-medium">Contact:</span> {manager_user.mobile_number}
            </p>
            <p>
              <span className="font-medium">
                {isTowingService && vendorRouteInfo?.totalDistance ? 'Total Route Distance:' : 'Distance:'}
              </span> {displayDistance.toFixed(1)} km
              {isTowingService && vendorRouteInfo?.totalDistance && (
                <span className="text-xs text-blue-600 ml-1">(3-point route)</span>
              )}
              {hasFuelLocation && vendorRouteInfo?.hasFuelLocation && (
                <span className="text-xs text-orange-600 ml-1">(includes fuel stop)</span>
              )}
            </p>
            <p className="text-xs text-gray-500 mt-2">
              {formatAddress(location_address)}
            </p>
            <p className="text-xs text-gray-500">
              <span className="font-medium">Status:</span> 
              <span className={`ml-1 ${operating_hours.is_open ? 'text-green-600' : 'text-red-600'}`}>
                {operating_hours.is_open ? 'Open' : 'Closed'}
              </span>
            </p>
          </div>
        </div>
        <div className="ml-4">
          <button 
            className="px-3 py-2.5 bg-scarlet-600 text-white text-sm font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            onClick={(e) => {
              e.stopPropagation(); // Prevent card click
              onShowDetails && onShowDetails(vendorLocationData);
            }}
          >
            More Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default VendorCard; 